/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `number` - Number
 * * `string` - String
 * * `choice` - Choice
 * * `boolean` - Boolean
 * * `date` - Date
 * * `datetime` - Datetime
 * * `warning` - Warning
 * * `table` - Table
 * * `file` - File
 * * `user` - User
 * @export
 */
export const FormFieldsFieldTypeEnum = {
    Number: 'number',
    String: 'string',
    Choice: 'choice',
    Boolean: 'boolean',
    Date: 'date',
    Datetime: 'datetime',
    Warning: 'warning',
    Table: 'table',
    File: 'file',
    User: 'user'
} as const;
export type FormFieldsFieldTypeEnum = typeof FormFieldsFieldTypeEnum[keyof typeof FormFieldsFieldTypeEnum];


export function instanceOfFormFieldsFieldTypeEnum(value: any): boolean {
    for (const key in FormFieldsFieldTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(FormFieldsFieldTypeEnum, key)) {
            if (FormFieldsFieldTypeEnum[key as keyof typeof FormFieldsFieldTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FormFieldsFieldTypeEnumFromJSON(json: any): FormFieldsFieldTypeEnum {
    return FormFieldsFieldTypeEnumFromJSONTyped(json, false);
}

export function FormFieldsFieldTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormFieldsFieldTypeEnum {
    return json as FormFieldsFieldTypeEnum;
}

export function FormFieldsFieldTypeEnumToJSON(value?: FormFieldsFieldTypeEnum | null): any {
    return value as any;
}

export function FormFieldsFieldTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): FormFieldsFieldTypeEnum {
    return value as FormFieldsFieldTypeEnum;
}

